import { StepSubmitted } from "../../components/CustomerForm/steps/StepSubmitted";

export function Success() {
	return (
		<>
			<StepSubmitted />
		</>
	);
}
